export default class AccessibilityDropdown {
    constructor(selector = '.dropdown-select-accessibility') {
        this.instances = document.querySelectorAll(selector);
        if (!this.instances.length) return;

        this.html = document.documentElement;

        this.themeStorageKey = 'theme-preference';
        this.fontStorageKey = 'font-size-preference';

        this.theme = this.getThemePreference();
        this.fontSize = this.getFontSizePreference();

        this.fontMin = 14;
        this.fontMax = 22;
        this.fontStep = 1;

        this.init();
    }

    init() {
        this.applyTheme(this.theme);
        this.applyFontSize(this.fontSize);

        this.instances.forEach(container => {
            this.initInstance(container);
        });
    }

    initInstance(container) {
        const button = container.querySelector('.btn-accessibility');
        const menu = container.querySelector('.list-accessibility');

        const contrastButtons = container.querySelectorAll('.btnActionContrast');
        const fontButtons = container.querySelectorAll('.btnFontSizeAction');

        const hasDropdown = !!button;
        let isOpen = false;

        if (hasDropdown && menu) {
            button.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                isOpen ? close() : open();
            });

            document.addEventListener('click', e => {
                // 🔒 IGNORA SE MODAL DE BUSCA ESTIVER ABERTO
                if (document.querySelector('.modal-busca.active')) return;

                if (isOpen && !container.contains(e.target)) {
                    close();
                }
            });

            document.addEventListener('keydown', e => {
                if (e.key === 'Escape' && isOpen) {
                    close();
                }
            });
        }

        const open = () => {
            isOpen = true;
            container.classList.add('is-open');
            menu.classList.remove('invisible', 'max-h-0');
            button?.setAttribute('aria-expanded', 'true');
        };

        const close = () => {
            isOpen = false;
            container.classList.remove('is-open');
            menu.classList.add('invisible', 'max-h-0');
            button?.setAttribute('aria-expanded', 'false');
        };

        /* CONTRASTE */
        contrastButtons.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                this.toggleContrast();
            });

            btn.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggleContrast();
                }
            });
        });

        /* FONTE */
        fontButtons.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                this.changeFont(btn.dataset.size);
            });

            btn.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.changeFont(btn.dataset.size);
                }
            });
        });
    }

    /* =========================
       CONTRASTE
    ========================== */

    toggleContrast() {
        this.theme = this.theme === 'dark' ? 'default' : 'dark';
        localStorage.setItem(this.themeStorageKey, this.theme);
        this.applyTheme(this.theme);
    }

    applyTheme(theme) {
        const isDark = theme === 'dark';

        this.html.setAttribute('data-theme', theme);
        this.html.classList.toggle('dark', isDark);

        document.querySelectorAll('.btnActionContrast').forEach(btn => {
            btn.classList.toggle('active', isDark);
            btn.setAttribute('aria-checked', String(isDark));
            btn.setAttribute(
                'aria-label',
                isDark
                    ? btn.dataset.labelActive || 'Alto contraste ativado'
                    : btn.dataset.labelInactive || 'Alto contraste desativado'
            );
        });
    }

    getThemePreference() {
        const stored = localStorage.getItem(this.themeStorageKey);
        if (stored) return stored;

        return 'default';
    }

    /* =========================
       FONTE
    ========================== */

    changeFont(action) {
        if (action === 'more') {
            this.fontSize = Math.min(this.fontSize + this.fontStep, this.fontMax);
        }

        if (action === 'less') {
            this.fontSize = Math.max(this.fontSize - this.fontStep, this.fontMin);
        }

        localStorage.setItem(this.fontStorageKey, this.fontSize);
        this.applyFontSize(this.fontSize);
    }

    applyFontSize(size) {
        this.html.style.fontSize = `${size}px`;

        document.querySelectorAll('.btnFontSizeAction').forEach(btn => {
            btn.classList.remove('active');
        });
    }

    getFontSizePreference() {
        const stored = localStorage.getItem(this.fontStorageKey);
        return stored ? parseInt(stored, 10) : 16;
    }
}

const initAccessibilityDropdown = () => {
    new AccessibilityDropdown();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessibilityDropdown);
} else {
    initAccessibilityDropdown();
}
